<template>
  <el-dialog
    title="用户换绑"
    :visible.sync="dialogVisible"
    width="70%"
  >
    <el-table
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column
        width="300"
      >
        <template slot-scope="scope">
          <div style="display: flex">
            <div
              style="width: 60px;margin-right: 4px;margin-top: 4px"
            >{{scope.$index ? '旧用户':'新用户'}}
            </div>
            <el-input
              v-model="scope.row.userId"
              placeholder="请输入用户id"
              clearable
              style="margin-right: 5px"
            />
            <el-button
              type="primary"
              @click="getDetail(scope)"
              style="width: 60px;height: 30px;padding: 4px;margin-top: 1px"
            >获取信息
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="nickname"
        label="昵称"
      >
      </el-table-column>
      <el-table-column
        label="头像"
        prop="avatar_url"
      >
        <template v-slot="scope">
          <img class="avatar" :src=scope.row.avatar_url>
        </template>
      </el-table-column>
      <el-table-column
        label="店铺名称"
        prop="shopName"
      >
      </el-table-column>
      <el-table-column
        label="店铺头像"
        prop="shopIcon"
      >
        <template v-slot="scope">
          <img class="shopPic" :src=scope.row.shopPic>
        </template>
      </el-table-column>
    </el-table>
    <div class="attention01">注：换绑后【新用户进入小程序将使用的是旧账户】</div>
    <div class="attention02">若操作失误请联系开发人员手动操作</div>
    <span slot="footer" class="dialog-footer">
    <el-button
      type="primary"
      @click="confirmExchange"
    >确定换绑</el-button>
  </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'UserExchange',
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      ChangeBindingURL: this.getDomain() + 'bmuser/change_binding_user',
      GetClientInfoURL: this.getDomain() + 'bmuser/get_client_info',
      tableData: [{
        userId: '',
        nickname: '',
        avatar_url: '',
        shopName: '',
        shopPic: ''
      }, {
        userId: '',
        nickname: '',
        avatar_url: '',
        shopName: '',
        shopPic: ''
      }]
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    }
  },
  methods: {
    getDetail (scope) {
      let params = {
        client_id: Number(scope.row.userId)
      }
      let handle = res => {
        scope.row.nickname = res.data.content.data.nickname
        scope.row.avatar_url = res.data.content.data.avatar_url
        scope.row.shopName = res.data.content.data.shop_name
        scope.row.shopPic = res.data.content.data.shop_pic
      }
      this.__axios(this.GetClientInfoURL, params, handle)
    },
    confirmExchange () {
      this.$confirm('新用户的账户将被永久删除, 是否继续?', '警告！', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dialogVisible = false
        let params = {
          new_client_id: Number(this.tableData[0].userId),
          old_client_id: Number(this.tableData[1].userId)
        }
        let handle = res => {}
        this.__axios(this.ChangeBindingURL, params, handle)
        this.$message({
          type: 'success',
          message: '换绑成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消该操作'
        })
      })
    }
  }
}
</script>

<style scoped>
  .avatar{
    width: 60px;
    height: 60px;
  }
  .shopPic{
    width: 60px;
    height: 60px;
  }
  .attention01 {
    margin-top: 10px;
  }
  .attention02 {
    margin-top: 5px;
    margin-left: 27px;
  }
</style>
